<div class="business-overdraft-application-details">
  <div fxLayout="column" fxLayoutGap="5px">
    <div>
      <breadcrumb (events)="onBreadcurmbEvents($event)" [trails]="breadcrumbTrails"></breadcrumb>
    </div>
    <div class="separator-bottom row">
      <div class="col-lg-8 col-md-12 mb-1"  fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-flat-button class="mat-flat-button-custom w-lt-md-100 btn-black-border">
          <application-type-icon applicationType="BusinessOverdraft" />
          Business Overdraft
          @if (application.Source == 'external') {
            <span class="ml-2 mdi mdi-alpha-e-circle" matTooltip="External source application"></span>
          }
          @if (application.Source == 'direct') {
            <span class="ml-2 mdi mdi-alpha-d-circle" matTooltip="Direct source application"></span>
          }
        </button>
      </div>
      <div class="col-lg-4 col-md-12 mb-1">
        <application-stage-icon [stage]="getApplicationStage(application)"></application-stage-icon>
      </div>
    </div>
  </div>

  <mat-tab-group
    [mat-stretch-tabs]="false"
    mat-align-tabs="start"
    [(selectedIndex)]="currentSectionIndex"
    (selectedTabChange)="onSelectedTabChange($event)">
    @for (currentTab of tabs; track currentTab) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="mdi {{currentTab.iconClass}}"></span>
          {{currentTab.name}}
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>


  @if (currentSection === 'asset') {
    <div class="row separator-bottom">
      <div class="col-12 btn-space header"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center start"
        >
        @if (allowContractGeneration) {
          <button mat-flat-button [disabled]="!applicationStageAllowGenerateContract(application)" (click)="openGenerateContractDialog()">
            <span class="mdi mdi-file-sign pr-2" matPrefix></span>
            <span class="label">Generate Contract</span>
          </button>
        }
        @if (activeContract && allowContractGeneration) {
          <button mat-flat-button (click)="openContractStatusDialog()">
            <span class="mdi mdi-account-supervisor-outline pr-2" matPrefix></span>
            <span class="label">Signer Status</span>
          </button>
        }
        <button mat-flat-button [disabled]="!applicationStageAllowSettleLoan(application)" (click)="onSettleLoan()">
          <span class="mdi mdi-cash-multiple pr-2" matPrefix></span>
          <span class="label">Request Settlement</span>
        </button>
      </div>
    </div>
  }


  <div>
    @if (currentSection === 'app') {
      <business-overdraft-app
        [getUserFn]="getUserFn"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (events)="events.emit($event)"
        [application]="application"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [updateApplicationFn]="updateApplicationFn"
        [data]="data"
        [getRatecardDetailsFn]="getRatecardDetailsFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        (navigateToApplications)="navigateToApplications.emit()"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
      </business-overdraft-app>
    }
    @if (currentSection === 'bank-statement') {
      <bank
        [apiUrl]="apiUrl"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [bankStatementsUrl]="bankStatementsUrl"
        [application]="application"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn">
      </bank>
    }
    @if (currentSection === 'asset') {
      <business-overdraft-settlement
        [application]="application"
        [data]="data"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn">
      </business-overdraft-settlement>
    }
    @if (currentSection === 'credit') {
        <business-overdraft-credit
          [application]="application"
          [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
          [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
          [getLvrCalculatorValueFn]="getLvrCalculatorValueFn"
          [updateLvrCalculatorValueFn]="updateLvrCalculatorValueFn"
          [runCreditFlowFn]="runCreditFlowFn"
          [getCreditWebServicesFn]="getCreditWebServicesFn"
          [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
          [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
          [updateCreditStatusFn]="updateCreditStatusFn"
          [updateCreditOfficerFn]="updateCreditOfficerFn"
          [getActiveCreditUsersFn]="getActiveCreditUsersFn"
          [getCreditAuditLogFn]="getCreditAuditLogFn"
          [getApplicationByIdFn]="getApplicationByIdFn"
          [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
          [deleteWebServicesFn]="deleteWebServicesFn"
          [apiUrl]="apiUrl"
          [requestMoreInformationFn]="requestMoreInformationFn"
          [getUserFn]="getUserFn"
          [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
          [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
          [createApplicationNoteFn]="createApplicationNoteFn"
          [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
          [getApplicationDscrFn]="getApplicationDscrFn"
          [getHistoricalContractsFn]="getHistoricalContractsFn"
          [getPismoContractsFn]="getPismoContractsFn"
          (viewReport)="onViewReport($event)"
          (clickApplicationEvent)="onClick($event)"
          (refreshCreditTabEvent)="refreshCreditTab($event)"
          />
    }
    @if (currentSection === 'credit-report') {
      <credit-report
        [getWebServiceReportFn]="getWebServiceReportFn"
        [apiUrl]="apiUrl"
        (leaveCreditReport)="onLeaveReport($event)"
      ></credit-report>
    }
    @if (currentSection === 'kyc-aml') {
      <kyc-verification
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
      [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
      [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
      [businessNumberSearchFn]="businessNumberSearchFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [application]="application">
      </kyc-verification>
    }
    @if (currentSection === 'documents') {
      <business-overdraft-documents
        [apiUrl]="apiUrl"
        [data]="data"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
         
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getUserFn]="getUserFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [application]="application"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [settleLoanFn]="settleLoanFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        >
      </business-overdraft-documents>
    }

    @if (currentSection === 'pricing') {
      <business-overdraft-pricing
        [application]="application"
        [currentRstValue] = "rst"
        [getContractStatusFn]="getContractStatusFn"
        [updateApplicationFn]="updateApplicationFn"
        [updateApplicationSfFn]="updateApplicationSfFn"
        [getRateCardDetailsFn]="getRatecardDetailsFn"
        [activeAccountDetails]="activeAccountDetails"
        [checkActiveOverdraftAccountFn]="checkActiveOverdraftAccountFn"
        (events)="onBusinessOverdraftPricingEvents($event)">
      </business-overdraft-pricing>
    }
  </div>
</div>
